import { useClickAway, useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'
import { HexAlphaColorPicker } from 'react-colorful'
import { ColorPickerContainer } from './style'

export const ColorPicker = ({
  color,
  onChange,
  onClose = () => {},
  left = -60,
  ...rest
}) => {
  const [value, setValue] = useState(color)
  const [isOpen, setIsOpen] = useState(false)
  useDebounce(() => isOpen && onChange(value), 100)

  const popover = useClickAway(() => {
    onClose()
    setIsOpen(false)
  })

  return (
    <ColorPickerContainer {...rest}>
      <div
        className="swatch"
        style={{ backgroundColor: color }}
        onClick={() => setIsOpen(true)}
      />

      {isOpen && (
        <div className="popover" ref={popover} style={{ left }}>
          <HexAlphaColorPicker color={color} onChange={setValue} />
        </div>
      )}
    </ColorPickerContainer>
  )
}
